import { useQuery } from '@tanstack/react-query';
import { getDiscountApprovers, getDiscountReasons, getSystemDiscounts } from 'queries';
import { getDiscountTypeTemplates } from 'queries/common/getDiscountTypes';

export const useDiscountData = (customerId?: string) => {
  const { data: discountReasons, isInitialLoading: isReasonsLoading } = useQuery(['discount-types'], getDiscountReasons);
  const { data: discountTypeTemplates, isInitialLoading: isTemplatesLoading } = useQuery(
    ['discount-type-templates', undefined],
    getDiscountTypeTemplates,
  );
  const { data: discountApprovers, isInitialLoading: isApproversLoading } = useQuery(
    ['discounts-approved-by-users'],
    getDiscountApprovers,
  );
  const { data: systemDiscounts, isInitialLoading: isSystemDiscountsLoading } = useQuery(
    ['discounts', customerId],
    getSystemDiscounts,
  );

  const isLoading = isReasonsLoading || isTemplatesLoading || isApproversLoading || isSystemDiscountsLoading;

  return { discountReasons, discountTypeTemplates, discountApprovers, systemDiscounts, isLoading };
};
